<template>
  <span>{{ formattedTime }}</span>
</template>

<script>
export default {
  props: {
    time: {
      type: String,
      required: true, // Time in format HH:mm:ss
    },
  },
  computed: {
    formattedTime() {
      // Split the time string (HH:mm:ss)
      const [hours, minutes] = this.time.split(":").map(Number);
      // Return formatted time in HH:mm
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.v-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
